<template>
    <div>
        <div class="startRecordBtn" @click="startRecording"></div>
        <div class="stopRecordBtn" @click="stopRecording"></div>
        <VModal @hideModal="previewModalClosed" ref="preview-screencast-video" class="preview-screencast-video" size="xl">
            <div class="clipboard">
                <div class="clipboard-head">
                    <form class="flex-center" @submit.prevent="uploadVideo">
                        <input class="clipboard-input" v-model="recording_name" type="text">
                        <div class="clipboard-btn">
                            <VButton
                                @clickHandler="uploadVideo"
                                active
                            >Upload</VButton>
                            <VButton
                                @clickHandler="() => $refs['delete-recording-modal'].$refs['delete-recording-modal'].showModal()"
                                theme="orange"
                                active
                            >Delete</VButton>
                        </div>
                    </form>
                    <div class="clipboard__copy-download">
                        <!-- <VButton @clickHandler="downloadImage">
                            <i class="icon-download-small"></i>
                            Download
                        </VButton> -->
                    </div>
                </div>
            </div>
            <div class="video-holder" v-if="videoOptions">
                <VideoPlayer :options="videoOptions" ref="recordedVideo" />
            </div>
        </VModal>

        <ConfirmDelete
            ref="delete-recording-modal"
            id="delete-recording-modal"
            class="delete-recording-modal"
            title="video"
            @delete="deleteVideo()"
        />

        <Flash ref="showFlash" />

        <div v-if="isRecording" class="recording-popup-holder">
            <div class="alert-message-container">
                <p>Recording in progress</p>
                <div class="record-btn-wrap">
                    <VButton @clickHandler="previewRecording" :disabled="isTaskEditing" active>Done</VButton>
                    <div class="record-time">{{ formattedTime }}</div>
                    <div class="record-indicator"></div>
                    <div class="stop-timer" @click="stopTimer"></div>
                </div>
            </div>
        </div>
        <VModal ref="record-status-modal" class="record-status-modal">
            <div class="text-holder" v-html="recordingNotif"></div>
            <VButton @clickHandler="hideRecordingNotif">Ok</VButton>
        </VModal>
    </div>
</template>
  
<script>
import VButton from "@/components/atoms/VButton";
import VModal from "@/components/atoms/VModal";
import ConfirmDelete from "@/components/organism/Confirm.vue";
import Flash from "@/components/Flash.vue";
import { mapState } from 'vuex';
import {getTagsAsArray} from "@/mixins/helpers";
import VideoPlayer from "@/components/atoms/VideoPlayer.vue";

export default {
    name: 'ScreenCast',
    components: { VButton, VModal, Flash, ConfirmDelete, VideoPlayer },
    data() {
        return {
            recorder: null,
            audioStream: null,
            mediaRecorder: null,
            recordedChunks: [],
            countdownInterval: null,
            recordedBlob: null,
            recording_name: `Recording ${new Date().getFullYear()}.${(new Date().getMonth() + 1).toString().padStart(2, '0')}.${new Date().getDate().toString().padStart(2, '0')}`,
            recordTime: 0,
            timer: null,
            recordingNotif: null,
            videoOptions: null
        };
    },
    computed: {
        ...mapState(['recordingInfo']),
        boardLists() {
            return this.$store.getters.activeBoardTasks
        },
        activeBoard() {
            return this.$store.getters.activeBoard
        },
        users() {
            return this.$store.getters.users
        },
        allTags() {
            return this.$store.getters.tags
        },
        isTaskEditing() {
			return this.$store.getters.isTaskEditing
		},
        recordingLimit() {
            return this.$store.getters.recordingLimit
        },
        isRecording() {
            return this.$store.getters.isRecording
        },
        formattedTime() {
            const minutes = Math.floor((60*this.recordingLimit - this.recordTime) / 60);
            const seconds = (60*this.recordingLimit - this.recordTime) % 60;
            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
        }
    },
    watch: {
        // recordingInfo(value) {
        //     if (value && value.recording) {
        //         this.startTimer()
        //     }
        // }
    },
    methods: {
        async startRecording() {
            this.showRecordingNotif(`Please, click allow access for<br>
                    recording the screen and audio.<br>
                    Click in the top for this.`)
            try {
                const displayStream = await this.getDisplayStream();
                const audioStream = await this.getAudioStream();

                const combinedStream = new MediaStream([
                    ...displayStream.getTracks(),
                    ...audioStream.getAudioTracks(),
                ]);

                this.setupMediaRecorder(combinedStream, displayStream.getVideoTracks()[0]);
                this.startTimer();

                this.$store.dispatch('setRecording', true)
                this.$store.dispatch('setRecordingInfo', {...this.recordingInfo, recording: true, clicked: false})

                this.$refs.show?.showFlashForever('Recording in progress');
                this.hideRecordingNotif()
            } catch ({name, message}) {
                console.error(name)
                console.error(message)
                if(navigator.mediaDevices.getDisplayMedia == undefined) {
                    alert('Mobile browsers do not support screen recordings.')
                } else if(name == 'NotAllowedError') {
                    this.showRecordingNotif(`You didn’t click allow.<br>
                    Or it was timeout.<br>
                    Anyhow, we can’t access your screen to<br>
                    record without this.<br>
                    Please try again.`)
                } else {
                    this.$refs.show?.showFlashError(message);
                }
                this.$store.dispatch('setRecording', false);
                this.$store.dispatch('setRecordingInfo', null)
            }
        },
        async stopRecording() {
            clearInterval(this.countdownInterval);
            console.log(this.mediaRecorder, this.isTaskEditing);
            if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive' && !this.isTaskEditing) {
                let tasks = this.boardLists.flatMap(list => list.tasks)
                if (tasks.length < 1 || tasks[0].project_id !== this.recordingInfo.project_id) {
                    this.$router.push(`/project/${this.recordingInfo.project_id}`)
                    this.$store.dispatch('setActiveBoard', this.recordingInfo.project_id);
                    this.$store.dispatch('resetTemplateTask');
                    setTimeout(() => {
                        tasks = this.boardLists.flatMap(list => list.tasks)
                        this.openTaskAfterRecordStop(tasks)
                        this.mediaRecorder.stream.getTracks().forEach(track => track.stop())
                    }, 1000)
                    return
                }
                this.openTaskAfterRecordStop(tasks)
                this.mediaRecorder.stream.getTracks().forEach(track => track.stop())
            } else if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive' && this.isTaskEditing) {
                this.$refs.showFlash?.showFlashWarning('Save or cancel changes first');
            } else {
                this.$refs.showFlash?.showFlashWarning('Something went wrong');
            }
            this.$store.dispatch('setRecording', false);
        },
        openTaskAfterRecordStop(tasks) {
            const task = tasks.filter(task => task.id == this.recordingInfo.id)[0]
            const list = this.boardLists.filter(list => list.id == task.list_id)[0]
            
            const usersMap = new Map(this.users?.map(user => [user?.id, user]))
            const tagMap = new Map(this.allTags?.map(tag => [tag?.id, tag]))
            let tags = getTagsAsArray(task, usersMap, tagMap)
            task.tags = tags
            //this.$store.dispatch('setEditableTask', task)

            this.$refs['preview-screencast-video'].showModal()
            this.$refs.show?.hideFlash();
        },
        setupMediaRecorder(stream, videoStream) {
            this.mediaRecorder = new MediaRecorder(stream);

            this.mediaRecorder.ondataavailable = (event) => {
                if (event.data.size > 0) {
                    this.recordedChunks.push(event.data);
                }
            };

            let ended = false

            videoStream.addEventListener('ended', () => {
                ended = true
                this.stopRecording()
                setTimeout(() => this.stopTracks(), 1000)
            });

            this.mediaRecorder.onstop = () => {
                if (!ended) {
                    this.stopTracks()
                }
            };

            this.mediaRecorder.start();
        },
        stopTracks() {
            this.recordedBlob = new Blob(this.recordedChunks, { type: 'video/mp4' });
            this.videoOptions = {
                autoplay: false,
                controls: true,
                sources: [
                    {
                        src: URL.createObjectURL(this.recordedBlob),
                        type: 'video/mp4'
                    }
                ]
            }
            this.$store.dispatch('setRecording', false)
            this.recordedChunks = [];
        },
        async getDisplayStream() {
		    return await navigator.mediaDevices.getDisplayMedia({ video: {frameRate: { max: 10 }, width: { max: 1280 }, height: { max: 720 }}});
        },
        async getAudioStream() {
            return await navigator.mediaDevices.getUserMedia({ audio: true });
        },
        // startCountdown() {
        //     console.log('startCountdown')
        //     let countdown = 60 * this.recordingLimit; // 60 seconds countdown
        //     this.countdownInterval = setInterval(() => {
        //         countdown--;

        //         if (countdown <= 0) {
        //             this.stopRecording();
        //             this.$refs.showFlash?.showFlashWarning('You recorded the maximum length.');
        //         }
        //     }, 1000);
        // },
        uploadVideo() {
            if (this.recordedBlob) {
                const file = new File([this.recordedBlob], `${this.recording_name}.${this.recordedBlob.type.split('/')[this.recordedBlob.type.split('/').length - 1] || '.mp4'}`, { type: 'video/mp4' });
                this.recordingInfo.uploadFunc([file], this.recordingInfo.id)
                this.deleteVideo()
                this.recording_name = `Recording ${new Date().getFullYear()}.${(new Date().getMonth() + 1).toString().padStart(2, '0')}.${new Date().getDate().toString().padStart(2, '0')}`
            }
        },
        deleteVideo() {
            this.videoOptions = null
            this.$refs['preview-screencast-video'].hideModal()
            this.recording_name = `Recording ${new Date().getFullYear()}.${(new Date().getMonth() + 1).toString().padStart(2, '0')}.${new Date().getDate().toString().padStart(2, '0')}`
        },
        previewModalClosed() {
            this.$store.dispatch('setRecordingInfo', null)
        },
        downloadImage() {
            
        },
        previewRecording() {
            this.stopTimer();
            this.stopRecording()
        },
        startTimer() {
            this.recordTime = 0;
            
            this.timer = setInterval(() => {
                this.recordTime++;

                if (this.recordTime >= 60 * this.recordingLimit) {
                    this.stopTimer()
                    this.stopRecording();
                    this.$refs.showFlash?.showFlashWarning('You recorded the maximum length.');
                }
            }, 1000);
        },
        stopTimer() {
            clearInterval(this.timer)
            this.recordTime = 0
        },
        showRecordingNotif(msg) {
            this.recordingNotif = msg
            this.$refs['record-status-modal'].showModal()
        },
        hideRecordingNotif() {
            this.$refs['record-status-modal'].hideModal()
        }
    }
};
</script>

<style scoped lang="scss">
.preview-screencast-video {
    position: absolute;
    z-index: 999;
    .modal {
        padding: 0 9px 0 !important;
    }

    .video-holder {
        position: relative;
        padding-bottom: 45%;
    }
}
.delete-recording-modal {
    position: absolute;
    z-index: 1000;
}

.record-status-modal {
    position: absolute;
    z-index: 1000;
    text-align: center;

    .text-holder {
        background: var(--secondary-bg);
        color: var(--primary-text);
        border-radius: 10px;
        padding: 15px;
        margin-bottom: 10px;
    }

    p {
        margin: 0;
    }
}

.recording-popup-holder {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    
    p { margin-bottom: 8px; }

    .alert-message-container {
        width: 151px;
        border-radius: 6px;
        backdrop-filter: blur(15px);
        font-size: 13px;
        font-weight: 300;
        line-height: 16px;
        padding: 8px;
        background: var(--primary-bg);
        color: var(--primary-text);

        .record-btn-wrap {
            display: flex;
            align-items: center;
            gap: 6px;
            .btn {
                width: 70px;
                height: 30px;
            }
            .record-time {
                width: 36px;
            }
        }
    }
}

</style>
